

export const getYouTubeVideoId = (url)=>{
    const urlParams = new URLSearchParams(new URL(url).search);
    return urlParams.get('v');
}